import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface Props {
  content: string;
}

export function MarkdownMessage({ content }: Props) {
  return (
    <div className="prose prose-invert prose-sm max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
        code({ className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '');
          const codeString = String(children).replace(/\n$/, '');

          // Check if this is a code block (has language or is multiline)
          const isCodeBlock = match || codeString.includes('\n');

          return isCodeBlock ? (
            <SyntaxHighlighter
              style={oneDark}
              language={match?.[1] || 'text'}
              PreTag="div"
              customStyle={{ margin: '0.5rem 0', borderRadius: '0.375rem' }}
            >
              {codeString}
            </SyntaxHighlighter>
          ) : (
            <code className="bg-gray-700 px-1 rounded text-sm" {...props}>
              {children}
            </code>
          );
        },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
